import React from "react"
import ProductPage from "../ProductPage/ProductPage"
import Page from "../Page/Page"

const InventoryPage = () => {
  return (
    <Page>
      <ProductPage />
    </Page>
  )
}

export default InventoryPage
